// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Banner-module--cds--assistive-text--f4b9e";
export var cdsVisuallyHidden = "Banner-module--cds--visually-hidden--46c47";
export var column = "Banner-module--column--3c4c2";
export var grid = "Banner-module--grid--dcbf9";
export var hideFeedback = "Banner-module--hide-feedback--c7e73";
export var row = "Banner-module--row--6bca0";
export var showFeedback = "Banner-module--show-feedback--3df05";
export var skeleton = "Banner-module--skeleton--cfe91";